// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"67":"7b9b130e","239":"f7c173f8","470":"9a933eed","542":"3ef2bcb0","587":"c05a5abe","667":"14bf61cf","926":"87838779","945":"846e9eca"}[chunkId] + ".js";
};